/*
 * @Description: 路由配置
 * @Author: hai-27
 * @Date: 2020-02-07 16:23:00
 * @LastEditors: hai-27
 * @LastEditTime: 2020-02-27 13:58:48
 */
import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("@/views/Home.vue"),
  },
   {
    path: "/contact",
    name: "contact",
    component: () => import("@/views/contact.vue"),
  },
  {
    path: "/goodsList",
    name: "goodsList",
    component: () => import("@/views/goodsList.vue"),
  },
  {
    path: "/product",
    name: "Product",
    component: () => import("../views/product.vue"),
  },
  {
    path: "/error",
    name: "Error",
    component: () => import("../components/Error.vue"),
  },
  {
    path: "/member/productCenter",
    name: "ProductCenter",
    component: () => import("../views/member/productCenter.vue"),
  },
  {
    path: "/member/cart",
    name: "Cart",
    component: () => import("../views/member/cart.vue"),
  },
  {
    path: "/member/address",
    name: "Address",
    component: () => import("../views/member/address.vue"),
  },
  {
    path: "/member/order",
    name: "Order",
    component: () => import("../views/member/order.vue"),
  },
  {
    path: "/member/archives",
    name: "Archives",
    component: () => import("../views/member/archives.vue"),
  },
  {
    path: "/member/account",
    name: "Account",
    component: () => import("../views/member/account.vue"),
  },
  {
    path: "/member/SuccessfullyOrdered",
    name: "SuccessfullyOrdered",
    component: () => import("../views/member/SuccessfullyOrdered.vue"),
  },
  {
    path: "/privacy",
    name: "Privacy",
    component: () => import("../views/privacy.vue"),
  },
  {
    path: "/TermsOfUse",
    name: "TermsOfUse",
    component: () => import("../views/TermsofUse.vue"),
  },
  {
    path: "/privacyApply",
    name: "PrivacyApply",
    component: () => import("../views/privacyApply.vue"),
  },
  {
    path: "/cookie",
    name: "Cookie",
    component: () => import("../views/cookie.vue"),
  },
  
];

const router = new Router({
  // base: '/dist',
  // mode: 'history',
  routes,
});

/* 由于Vue-router在3.1之后把$router.push()方法改为了Promise。所以假如没有回调函数，错误信息就会交给全局的路由错误处理。
vue-router先报了一个Uncaught(in promise)的错误(因为push没加回调) ，然后再点击路由的时候才会触发NavigationDuplicated的错误(路由出现的错误，全局错误处理打印了出来)。*/
// 禁止全局路由错误处理打印
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};

export default router;
